export const cyborgInit = () => {
    const cyborg = document.querySelector("#cyborg");
    if (!cyborg) {
        return;
    }

    const sprite = new Image();
    sprite.src = "/images/cyborg3.png";

    let cyborgAnim = {
        WIDTH: 200,
        HEIGHT: 285,
        GAP: 2,
        FRAMES: 707,
        FRAMES_IN_LINE: 31,
        ctx: null,
        canvas: null,
        // sprite: new Image(),
        frame: 0,
        line: 0,
        idAnimationFrame: null,
        timePerFrame: 33,
        // FILE: (this.sprite.src = "/images/cyborg3.png"),
        init() {
            try {
                this.canvas = document.querySelector("#cyborg-canvas");
                if (!this.canvas) {
                    return false;
                }
                this.ctx = this.canvas.getContext("2d");
                this.canvas.width = this.WIDTH;
                this.canvas.height = this.HEIGHT;
                // this.sprite = new Image();
                // this.sprite.src = this.FILE;
                return true;
            } catch (err) {
                console.error(err);
                return false;
            }
        },
        anim() {
            let interval = setInterval(() => {
                this.frame++;
                if (this.frame > this.FRAMES) {
                    clearInterval(interval);
                    this.stop();
                }
                if (this.frame > this.FRAMES_IN_LINE - 1) {
                    this.frame = 0;
                    this.line++;
                }
            }, this.timePerFrame);
        },
        render() {
            this.ctx.clearRect(0, 0, this.WIDTH, this.HEIGHT);
            let indent = this.frame > 0 ? this.WIDTH + this.GAP : this.WIDTH;
            let slideW = this.frame * indent;
            let slideH = this.line * (this.HEIGHT + this.GAP) + this.GAP;
            this.ctx.drawImage(sprite, slideW, slideH, this.WIDTH, this.HEIGHT, 0, 0, this.WIDTH, this.HEIGHT);
        },
        run() {
            this.idAnimationFrame = window.requestAnimationFrame(() => {
                this.render();
                this.run();
            });
        },
        start() {
            const isStart = this.init();
            if (!isStart) {
                return;
            }
            this.anim();
            this.run();
        },
        stop() {
            cancelAnimationFrame(this.idAnimationFrame);
        },
    };

    let step = 0;
    const animationSteps = [
        { dur: 3000, class: "cyborg" },
        { dur: 1500, class: "cyborg step1" }, // Привет, я Sairus
        { dur: 3000, class: "cyborg step2" }, // Рад тебя приветствовать
        { dur: 2000, class: "cyborg step3" }, // Присоединяйся к нам.
        { dur: 4000, class: "cyborg step4" }, // Я работаю на искусственном интеллекте
        { dur: 3000, class: "cyborg step5" }, // Нажми на кнопку
        { dur: 3000, class: "cyborg step6" }, // Если нужна помощь, пишите мне в
        { dur: 1700, class: "cyborg" },
        { dur: 1000, class: "cyborg stop" },
    ];

    function steps() {
        cyborg.className = animationSteps[step].class;
        step++;
        if (step > animationSteps.length - 1) {
            return;
        }
        setTimeout(steps, animationSteps[step - 1].dur);
    }

    // setTimeout(() => {

    // }, 1000);

    sprite.onload = () => {
        cyborgAnim.start();
        steps();
    };
};
